import React, { useState, useEffect } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  TextField,
  Typography,
  IconButton,
  Divider,
} from "@mui/material";
import { Close } from "@mui/icons-material";

const EditNoteDialog = ({ open, onClose, initialNote = "", onSave, onDelete }) => {
  const [note, setNote] = useState(initialNote || "");
  const [inputError, setInputError] = useState("");

  useEffect(() => {
    if (open) {
      setNote(initialNote || "");
      setInputError("");
    }
  }, [open, initialNote]);

  const handleNoteChange = (e) => {
    const value = e.target.value;
    if (value.length <= 2000) {
      setNote(value);
      setInputError("");
    } else {
      setInputError("You can only input 2000 characters");
    }
  };

  const handleSave = () => {
    if (!note || Boolean(inputError)) return;
    onSave(note);
  };

  const handleDelete = () => {
    onDelete();
  };

  return (
    <Dialog
      open={open}
      onClose={onClose}
      PaperProps={{
        sx: {
          borderRadius: "12px",
          padding: "12px",
          width: 600,
          boxShadow: "0px 4px 12px rgba(0, 0, 0, 0.1)",
        },
      }}
    >
      <DialogTitle
        sx={{
          fontSize: { xs: "16px", md: "18px" },
          color: "#303f9f",
          fontWeight: "bold",
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
        }}
      >
        Add a Note
        <IconButton
          onClick={onClose}
          sx={{
            color: "#303f9f",
            "&:hover": { backgroundColor: "rgba(48, 63, 159, 0.1)" },
            p: 0.5,
            borderRadius: "50%",
            minWidth: 32,
            height: 32,
          }}
          aria-label="Close"
        >
          <Close sx={{ fontSize: 18 }} />
        </IconButton>
      </DialogTitle>

      <Divider />

      <DialogContent
        sx={{
          display: "flex",
          flexDirection: "column",
          padding: "12px",
          gap: "8px",
          overflowY: "hidden",
        }}
      >
        <Typography variant="caption" sx={{ fontWeight: 500, color: "text.secondary" }}>
          Notes
        </Typography>
        <TextField
          variant="outlined"
          fullWidth
          placeholder="Write your note here..."
          multiline
          rows={7}
          value={note}
          onChange={handleNoteChange}
          InputProps={{ sx: { fontSize: "14px", padding: "12px", borderRadius: "6px" } }}
          error={Boolean(inputError)}
          helperText={inputError}
        />
      </DialogContent>

      <DialogActions
        sx={{ justifyContent: "flex-end", paddingTop: { xs: "0px", md: "16px" } }}
      >
        <Button
          variant="contained"
          color="error"
          onClick={handleDelete}
          disabled={!note}
          sx={{
            borderRadius: "24px",
            fontSize: { xs: "13px", lg: "14px" },
            padding: "8px 24px",
            textTransform: "none",
            fontWeight: "bold",
            ml: 2,
          }}
        >
          Delete
        </Button>
        <Button
          variant="outlined"
          color="primary"
          onClick={handleSave}
          disabled={Boolean(inputError)}
          sx={{
            borderRadius: "24px",
            fontSize: { xs: "13px", lg: "14px" },
            padding: "8px 24px",
            textTransform: "none",
            fontWeight: "bold",
          }}
        >
          Save
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default EditNoteDialog;
